import get from 'lodash/get';

export function priceTypeToSlug (pricetype) {
  return get(pricetype, 'code', '').replace(/[\W]/g, '');
}

export function getDataAttributeSelectorString (name, value) {
  return `[data-${name}="${value}"]`;
}

export default  {
  getDataAttributeSelectorString: getDataAttributeSelectorString,
  priceTypeToSlug: priceTypeToSlug
};



// WEBPACK FOOTER //
// ./frontend/react/utils/pricetype/pricetype_utils.js